import getFacilityName from 'utils/print/getFacilityName';
import getFacilityAddress from 'utils/print/getFacilityAddress';

const getFacilityNameAndAddress = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const facilityName = getFacilityName(otherProps);
  const facilityAddress = getFacilityAddress(otherProps);
  return facilityName && facilityAddress
    ? `${facilityName}, ${facilityAddress}` : null;
};

export default getFacilityNameAndAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityNameAndAddress.js